<div class="form-group ">
  <label for="{{className}}" class="mr-2" ngClass="{'label-style': !basicStyle , 'control-label' : basicStyle">{{label |
    translate}}</label>
  <input id="{{className}}" type="radio" name="{{className}}"
         class="{{className}}">

</div>
